import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9f95f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-title" }, "请使用手机号验证码进行登录", -1))
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#3370ff","margin-bottom":"10px"} }, " 手机登录后在不同电脑设备上可查看聊天记录 ", -1))

import {
  reactive,
  ref,
  getCurrentInstance,
  onMounted,
  onBeforeMount,
} from 'vue'

import { FormInstance, ElMessage } from 'element-plus'
import { TUIEnv } from '@/TUIKit/TUIPlugin'
import { TUICore, genTestUserSig } from '@/TUIKit'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import VueCookies from 'vue-cookies'
import emitter from '@/utils/emitter'
// import router from '../router';
// import TUIAegis from "./TUIKit/utils/TUIAegis";
import axios from 'axios'
import SliderCheck from './SliderCheck.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IsLogin',
  props: {
  loginParams: { type: Object, required: true },
  isLoginRef: { type: Boolean, required: true },
  isH5: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props

const contentFlag = ref(true)
// const btn = () => {
//     emitter.emit("fn", str);
// };

const dialogVisible = ref(true)
const show = ref(true)
const timer = ref()
const TIME_COUNT = ref(60)
const count = ref()
const ruleFormRef = ref<FormInstance>()
const instance = getCurrentInstance()
const TUIKit: any = instance?.appContext.config.globalProperties.$TUIKit
const SDKAppID = 1400757726 // Your SDKAppID
const secretKey =
  'eba746b5cc1ce62cd8a4df7a02128272f296a6dba656d77e2e63a7c0d27b758f' //Your secretKey
const router = useRouter()
const domain = '.dzsc.com'

const internalData = instance?.appContext.config.globalProperties

internalData?.$cookies.config('', '', domain)

const isAccount = ref(false)

const validateAccount = (rule: any, value: any, callback: any) => {
  const reg = /^(?:(?:\+|00)86)?1\d{10}$/
  if (value === '') {
    isAccount.value = false
    callback(new Error('请输入手机号码'))
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号码'))
  } else {
    callback()

    return (isAccount.value = true)
  }
}

const validatePass = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入验证码'))
  } else {
    if (ruleForm.password !== '') {
      if (!ruleFormRef.value) return
      // validateField 验证具体的某个字段。
      ruleFormRef.value.validateField('checkPass', () => null)
    }
    callback()
  }
}
const isLockedRef = ref(false)
const handleSuccessFun = () => {
  if (ruleForm.account !== '') {
    isLockedRef.value = true
    // console.log("滑动成功");
  } else {
    alert('请先输入手机号')
    isLockedRef.value = false
  }
}

// 滑块验证失败回调
const handleErrorFun = () => {
  // console.log("滑动失败");
  isLockedRef.value = false
}
const ruleForm = reactive({
  account: '',
  password: '',
})

const isLocked = () => {
  if (ruleForm.account == '') {
    ElMessage({
      message: '请输入手机号',
      type: 'warning',
    })
    return
  }
  // if (!isLockedRef.value) {
  //     console.log("请先拖动滑块到最右边");

  //     ElMessage({
  //         message: "请先拖动滑块到最右边",
  //         type: "warning",
  //     });
  //     return;
  // }
  if (ruleForm.account !== '' && isLockedRef.value === true) {
    GetMobileSMSCode()
    // console.log("发送成功");
  }
}
// rules 表单验证规则
const rules = reactive({
  // trigger 验证逻辑的触发方式	'blur' | 'change'
  account: [{ validator: validateAccount, trigger: 'blur' }],
  password: [{ validator: validatePass, trigger: 'blur' }],
})


// eslint-disable-next-line vue/no-setup-props-destructure
const allparams = props.loginParams

const { tempname, username, url, keyword, pagetype } = allparams
// const regTempName = /^temp\w+/;

const MPuserName = internalData?.$cookies.get('MPuserName');
// const MPuserName = localStorage.getItem("MPuserName");
// console.log(MPuserName !== null && MPuserName == tempname);

if (MPuserName !== null) {
  // 成功 用手机号登录
  // 存在本地 手机登录名 且 url上的tempname与本地手机登录名一致 登录框不显示
  dialogVisible.value = false
} else {
  // 失败 未用手机号登录
  dialogVisible.value = true
}

// let ClickTime = JSON.parse(localStorage.getItem('ClickTime') || '0')
let ClickTime = internalData?.$cookies.get('ClickTime')

console.log(ClickTime, 'ClickTime123')

let nowTime = Date.now()
if (nowTime - ClickTime > 1000 * 3600 * 24) {
  dialogVisible.value = true
} else {
  dialogVisible.value = false
  const url = window.location.href
  let allParams = url.split('?')[1]
  let params = new URLSearchParams(allParams)
  const MyTempName = params.get('tempname')
  TUIKit.login({
    userID: MyTempName,
    userSig: genTestUserSig({
      SDKAppID,
      secretKey,
      userID: MyTempName,
    }).userSig,
  })
}
// 匿名询盘
const AnonymousInquiry = function () {
  const url = window.location.href
  let allParams = url.split('?')[1]
  let params = new URLSearchParams(allParams)
  const MyTempName = params.get('tempname')
  TUIKit.login({
    userID: MyTempName,
    userSig: genTestUserSig({
      SDKAppID,
      secretKey,
      userID: MyTempName,
    }).userSig,
  })
  emitter.emit('componyShow', contentFlag)
  dialogVisible.value = false

  const clickTime: any = new Date().getTime()
  // console.log(clickTime, 'clickTime')

  let ClickTime = Date.now()
  // localStorage.setItem('ClickTime', JSON.stringify(ClickTime))
  internalData?.$cookies.set('ClickTime', JSON.stringify(ClickTime))
}

const PostLoginMobile = function () {
  const params = {
    mobile: ruleForm.account,
    smscode: ruleForm.password,
  }

  axios({
    method: 'post',
    url: '/api/User/LoginMobile',
    params,
  })
    .then((res) => {
      if (res.status !== 200) return
      if (res.data.successCode === 1) {
        const MPuserName = res.data.resultData[0].mobile
        if (internalData?.$cookies.isKey('MPuserName')) {
          internalData?.$cookies.remove('MPuserName')
        }
        internalData?.$cookies.set('MPuserName', MPuserName)
        internalData?.$cookies.config('1m')

        TUIKit.login({
          userID: MPuserName,
          userSig: genTestUserSig({
            SDKAppID,
            secretKey,
            userID: MPuserName,
          }).userSig,
        })
        dialogVisible.value = false
        // const clickTime: any = new Date().getTime();
        // console.log(clickTime, "clickTime");

        let ClickTime = Date.now()
        // localStorage.setItem('ClickTime', JSON.stringify(ClickTime))
        internalData?.$cookies.set('ClickTime', JSON.stringify(ClickTime))
        location.reload()
      } else {
        ElMessage({
          message: '验证码不正确,请重新输入',
          type: 'warning',
        })
      }
    })
    .catch((err) => {
      console.log(err, '手机验证码不正确，请输入正确的手机号和验证码')
    })
}

const GetMobileSMSCode = function () {
  if (!timer.value) {
    count.value = TIME_COUNT.value
    show.value = false
    timer.value = setInterval(() => {
      if (count.value > 0 && count.value <= TIME_COUNT.value) {
        count.value--
        // console.log("count----", count);
      } else {
        show.value = true
        clearInterval(timer.value)
        timer.value = null
      }
    }, 1000)
  }

  axios
    .get('/api/User/GetMobileSMSCode?mobile=' + ruleForm.account)
    .then((res) => {
      if (res.status !== 200) return
      if (res.data.successCode === 1) {
        ElMessage({
          message: '验证码发送成功',
          type: 'success',
        })
      } else {
        ElMessage({
          message: '验证码发送失败',
          type: 'warning',
        })
      }
    })
    .catch((err) => {
      console.log(err, '失败')
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      width: "350px",
      draggable: true,
      "show-close": false,
      "close-on-press-escape": false,
      "close-on-click-modal": false
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            "status-icon": "",
            rules: rules,
            class: "demo-ruleForm"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_el_form_item, { prop: "account" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.account,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.account) = $event)),
                    placeholder: "请输入手机号码"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(SliderCheck, {
                    successFun: handleSuccessFun,
                    errorFun: handleErrorFun,
                    isAccount: isAccount.value,
                    isH5: __props.isH5
                  }, null, 8, ["isAccount", "isH5"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "password" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
                    placeholder: "请输入短信验证码",
                    autocomplete: "off",
                    style: {"width":"210px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"width":"80px","margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("span", { onClick: isLocked }, "获取验证码", 512), [
                        [_vShow, show.value]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "count" }, _toDisplayString(count.value) + " s ", 513), [
                        [_vShow, !show.value]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"width":"300px"},
                    onClick: PostLoginMobile
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("登录")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"width":"300px","margin":"10px 0 0 0","background-color":"#0da500","border-color":"#0da500"},
                    onClick: AnonymousInquiry
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("匿名直接询盘")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})